import { render, staticRenderFns } from "./DirectSverka.vue?vue&type=template&id=047d0e2b&scoped=true"
import script from "./DirectSverka.vue?vue&type=script&lang=js"
export * from "./DirectSverka.vue?vue&type=script&lang=js"
import style0 from "./DirectSverka.vue?vue&type=style&index=0&id=047d0e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d0e2b",
  null
  
)

export default component.exports